module.exports = __webpack_public_path__ + "assets/img/phone.d36e8dad.png";